import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGif = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 2C2.68629 2 0 4.68629 0 8V16C0 19.3137 2.68629 22 6 22H18C21.3137 22 24 19.3137 24 16V8C24 4.68629 21.3137 2 18 2H6ZM7.93347 16.033C9.81335 16.033 11.0145 14.866 11.0145 13.0447V12.1658H8.08972V13.1277H9.77917L9.77429 13.2742C9.75964 14.2751 9.02722 14.9441 7.953 14.9441C6.69812 14.9441 5.9071 13.9431 5.9071 12.3269V12.3171C5.9071 10.7253 6.68347 9.72437 7.91394 9.72437C8.81726 9.72437 9.46179 10.1736 9.69128 10.9451L9.70593 10.9939H10.9559L10.951 10.9451C10.7118 9.56812 9.53992 8.6355 7.91394 8.6355C5.9071 8.6355 4.62292 10.0759 4.62292 12.3269V12.3367C4.62292 14.6121 5.89246 16.033 7.93347 16.033ZM12.2051 15.8572H13.4648V8.81128H12.2051V15.8572ZM16.1886 15.8572H14.9288V8.81128H19.421V9.87085H16.1886V11.9558H19.1427V12.9812H16.1886V15.8572Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgGif);
export default ForwardRef;
